var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{
        active: _vm.isActive
    },on:{"click":_vm.openTab}},[_c('feather-icon',{attrs:{"type":"x","color":_vm.isActive ? '#ff9f43' : '#000'},on:{"click":_vm.doRemoveTab}}),_vm._v(" "),_c('span',[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_vm._v("\n                "+_vm._s(_vm.label)+"\n            ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }